
import { Component, Watch, Vue } from 'vue-property-decorator';

import Highcharts from 'highcharts';
import dataModule from 'highcharts/modules/data';
import exporting from 'highcharts/modules/exporting';
import exportData from 'highcharts/modules/export-data';

dataModule(Highcharts);
exporting(Highcharts);
exportData(Highcharts);

@Component({})
export default class StorylinesV extends Vue {
    config: any = undefined;
    loaded = false;

    activeChapterIndex = -1;
    lang = 'en';

    @Watch('$i18n.locale')
    onLangChange(newLang: string, oldLang: string) {
        this.lang = newLang;
        this.fetchConfig(`storylines/storylines_${newLang}.json`);
    }

    created(): void {
        this.lang = this.$router.currentRoute.query['lang']
            ? (this.$router.currentRoute.query['lang'] as string)
            : this.lang;
        this.fetchConfig(`storylines/storylines_${this.lang}.json`);
    }

    fetchConfig(fileName: string) {
        // fetch demo storylines config file contents
        this.loaded = false;
        fetch(fileName)
            .then((res) => {
                res.json().then((config) => {
                    this.config = config;
                    this.loaded = true;
                });
            })
            .catch((err) => {
                console.error(`There was an error fetching the Storylines config: ${err}`);
            });
    }

    updateActiveIndex(idx: number): void {
        this.activeChapterIndex = idx;
    }
}
